import { render, staticRenderFns } from "./gd_zhuanjia.vue?vue&type=template&id=52e7a824&scoped=true"
import script from "./gd_zhuanjia.vue?vue&type=script&lang=js"
export * from "./gd_zhuanjia.vue?vue&type=script&lang=js"
import style0 from "./gd_zhuanjia.vue?vue&type=style&index=0&id=52e7a824&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7a824",
  null
  
)

export default component.exports